import React from 'react';
import { Link } from '@tanstack/react-router';
import { ROUTES } from 'app/javascript/constants/routes';
import StoreBadges from 'app/javascript/components/shared/StoreBadges';

const InstagramIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const TikTokIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.66a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.09z" />
  </svg>
);

const socialLinks = [
  {
    name: 'Instagram',
    handle: '@blackbelts.app',
    href: 'https://www.instagram.com/blackbelts.app',
    Icon: InstagramIcon,
  },
  {
    name: 'TikTok',
    handle: '@blackbelts.app',
    href: 'https://www.tiktok.com/@blackbelts.app',
    Icon: TikTokIcon,
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="relative z-10 px-4 sm:px-6 py-12 border-t border-gray-800">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-6 text-center">
        <StoreBadges size="sm" className="justify-center" />
        <nav aria-label="Links institucionais" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm">
          <Link to={ROUTES.COMPANY_LANDING} className="text-slate-400 hover:text-yellow-400 transition-colors">
            Para academias
          </Link>
          <Link to={ROUTES.FACE_RECOGNITION_LANDING} className="text-slate-400 hover:text-yellow-400 transition-colors">
            Reconhecimento facial
          </Link>
          <Link
            to={ROUTES.GUIDE_INDEX}
            reloadDocument
            className="text-slate-400 hover:text-yellow-400 transition-colors"
          >
            Central de Ajuda
          </Link>
          <Link
            to={ROUTES.PRIVACY_POLICY}
            reloadDocument
            className="text-slate-400 hover:text-yellow-400 transition-colors"
          >
            Privacidade
          </Link>
          <Link
            to={ROUTES.TERMS_OF_USE}
            reloadDocument
            className="text-slate-400 hover:text-yellow-400 transition-colors"
          >
            Termos
          </Link>
        </nav>
        <ul className="flex flex-col sm:flex-row items-center gap-3 sm:gap-5">
          {socialLinks.map(({ name, handle, href, Icon }) => (
            <li key={name}>
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`BlackBelts no ${name} (${handle})`}
                className="group flex items-center gap-3 rounded-full border border-slate-700 px-4 py-2 text-slate-400 transition hover:border-yellow-400 hover:text-yellow-400"
              >
                <Icon className="h-5 w-5 shrink-0" />
                <span className="flex flex-col items-start leading-tight text-left">
                  <span className="text-[11px] uppercase tracking-[0.18em] text-slate-500 group-hover:text-yellow-400/80">
                    {name}
                  </span>
                  <span className="text-sm font-medium text-slate-300 group-hover:text-yellow-400">
                    {handle}
                  </span>
                </span>
              </a>
            </li>
          ))}
        </ul>
        <div className="flex flex-col items-center gap-1">
          <p className="text-sm text-slate-500 uppercase tracking-wider">
            &copy; {new Date().getFullYear()} BlackBelts Academy Management
          </p>
          <p className="text-xs text-slate-500">
            <span className="font-medium text-slate-400">blackbelts.app</span> é um serviço da Agix Tecnologia.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
